import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import FormSousLot from "./FormSousLot";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Collapse from "react-bootstrap/Collapse";
import {
  BsFillArrowUpSquareFill,
  BsFillArrowDownSquareFill,
} from "react-icons/bs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import * as mem from "./recopieLotFournisseur";
import * as intchaine from "./interface-chaine";
import axios from "axios";
import ModalCreationLot from "./ModalCreationLot ";
import { DEBUG } from "./utilitaires";

export default function FormCreerLot() {
  const [open, setOpen] = useState(true); //pour les collapse
  //on va systématiquement copier les valeurs éventuellement mémorisées pour le lot
  var val;
  val = mem.getChampLot("numFournisseur");
  const [numFournisseur, setNumFournisseur] = useState(val);
  val = mem.getChampLot("libelle");
  const [libelle, setLibelle] = useState(val);
  val = mem.getChampLot("image");
  const [image, setImage] = useState(val);
  val = mem.getChampLot("descr");
  const [descr, setDescr] = useState(val);
  val = mem.getChampLot("arg");
  const [arg, setArg] = useState(val);
  val = mem.getChampLot("nbreArt");
  const [nbreArt, setNbreArt] = useState(val);
  val = mem.getChampLot("pourcentExt");
  const [pourcentExt, setPourcentExt] = useState(val);
  val = mem.getChampLot("carbone");
  const [carbone, setCarbone] = useState(val);
  // val = mem.getChampLot("carboneTot");
  // const [carboneTot, setCarboneTot] = useState(val);
  // val = mem.getChampLot("carbonePert");
  // const [carbonePert, setCarbonePert] = useState(val);
  val = mem.getChampLot("DLC");
  const [DLC, setDLC] = useState(val);
  val = mem.getChampLot("couleur");
  const [couleurTitre, setCouleurTitre] = useState(val);  

  const [LotsCount, setLotsCount] = useState(1);
  const [inputList, setInputList] = useState([]);
  // const [verifErreur, setVerifErreur] = useState(false)

  const [msgErreurNumFournisseur, setMsgErreurNumFournisseur] = useState("");
  const [msgErreurLibelle, setMsgErreurLibelle] = useState("");
  const [msgErreurImage, setMsgErreurImage] = useState("");
  const [msgErreurDescr, setMsgErreurDescr] = useState("");
  const [msgErreurArg, setMsgErreurArg] = useState("");
  const [msgErreurNbreArt, setMsgErreurNbreArt] = useState("");
  const [msgErreurPourcentExt, setMsgErreurPourcentExt] = useState("");
  const [msgErreurCarbone, setMsgErreurCarbone] = useState("");
  const [msgErreurCarboneTot, setMsgErreurCarboneTot] = useState("");
  const [msgErreurCarbonePert, setMsgErreurCarbonePert] = useState("");
  const [msgErreurDLC, setMsgErreurDLC] = useState("");
  // const [autoriseF, setAutoriseF] = useState(false);

  // const [couleurTitre, setCouleurTitre] = useState("black");

  //pour le modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //pour modal annuler
  const [showAnnuler, setShowAnnuler] = useState(false);
  const handleCloseAnnuler = () => setShowAnnuler(false);

  //pour modal supprimer sous-lot
  const [showSuppSousLot, setShowSuppSousLot] = useState(false);
  const [msgModalSuppSousLot, setMsgModalSuppSousLot] = useState("");  
  const [sousLotSupp, setSousLotSupp] = useState(0);   
  const handleCloseSuppSousLot = () => setShowSuppSousLot(false);
  
  //var sousLotSupp = 0;

  //pour fichier image
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [tilt, setTilt] = useState(true);

  // pour le Modal CreationLot
  const [creationLot, setCreationLot] = useState(false);

  //lire à l'initialisation les valeurs mises en mémoire pour les souslots (sinon "")
  useEffect(() => {
    var lesSousLots = mem.lesSousLotsEnMemoire;
    var listetemp = [];
    for (var i = 0; i < lesSousLots.length; i++) {
      //on boucle sur les sous-lots sauvegardés
      let identSousLot = lesSousLots[i]["ident"];
      let typeSousLot = lesSousLots[i]["type"];
      // let couleurSousLot = lesSousLots[i]["couleur"];
      //on constitue la liste qu'on affichera ensuite
      listetemp = [
        ...listetemp,
        {
          id: identSousLot,
          jsx: (
            <>
              <FormSousLot
                ident={identSousLot}
                type={typeSousLot}
                verif={false} //on demandera plus tard la vérification s'il y a une erreur quelque part
                open={false}
                // couleur={couleurSousLot}
              />
              <p
                style={{ color: "red", cursor: "pointer" }}
                onClick={(event) => clickRemoveSousLot(event, identSousLot)}
              >
                - Supprimer le sous-lot {identSousLot}
              </p>
              {/* <br></br> */}
            </>
          ),
        },
      ];
      setLotsCount(identSousLot + 1);
    }
    setInputList(listetemp);
    // setAutoriseF(intchaine.fournisseurAutorise(intchaine.accountFournisseur))
  }, []);

  // pour rajouter un souslot dans la liste
  const clickRajouterSousLot = (event, typeSousLot) => {
    event.preventDefault();
    if (DEBUG) console.log("je rajoute un sous-lot de type ", typeSousLot);
    setInputList([
      ...inputList,
      {
        id: LotsCount,
        jsx: (
          <>
            <FormSousLot
              ident={LotsCount}
              type={typeSousLot}
              verif={false}
              open={true}
              // couleur={"black"}
            />
            <p
              style={{ color: "red", cursor: "pointer" }}
              onClick={(event) => clickRemoveSousLot(event, LotsCount)}
            >
              - Supprimer le sous-lot {LotsCount}
            </p>
            {/* <br></br> */}
          </>
        ),
      },
    ]);
    setLotsCount((old) => old + 1);
    // mem.afficherLengthSousLots()
  };

  function clickRemoveSousLot(e, id) {
    if (DEBUG) console.log("remove Sous Lot n° ", id);
    e.preventDefault();
    //sousLotSupp = id;
    setSousLotSupp(id);
    setMsgModalSuppSousLot("Etes-vous sûr de vouloir supprimer le sous-lot " + id + " ?");
    setShowSuppSousLot(true);
    // mem.enleverSousLot(id);
    // setInputList((old) => old.filter((lot) => lot.id !== id));
    // console.log("nb de sous lots:", mem.afficherLengthSousLots());
  }

  function suppSousLot(e) {
    e.preventDefault();
    if (DEBUG) console.log("Dans suppSousLot, je supprime le sous-lot: ", sousLotSupp);
    mem.enleverSousLot(sousLotSupp);
    setInputList((old) => old.filter((lot) => lot.id !== sousLotSupp));  
    setSousLotSupp(0); 
    setMsgModalSuppSousLot("");
    setShowSuppSousLot(false);
  }



  //changer au moindre input
  function changerNumFournisseur(e, value) {
    e.preventDefault();
    setMsgErreurNumFournisseur("");
    mem.changerChampLot("numFournisseur", value);
    setNumFournisseur(value);
  }
  function changerLibelle(e, value) {
    e.preventDefault();
    setLibelle(value);
    setMsgErreurLibelle("");
    mem.changerChampLot("libelle", value);
  }
  function changerImage(e, value) {
    e.preventDefault();
    setImage(value);
    setMsgErreurImage("");
    mem.changerChampLot("image", value);
  }
  function changerDescr(e, value) {
    e.preventDefault();
    setDescr(value);
    setMsgErreurDescr("");
    mem.changerChampLot("descr", value);
  }
  function changerArg(e, value) {
    e.preventDefault();
    setArg(value);
    setMsgErreurArg("");
    mem.changerChampLot("arg", value);
  }
  function changerNbreArt(e, value) {
    e.preventDefault();
    setNbreArt(value);
    setMsgErreurNbreArt("");
    mem.changerChampLot("nbreArt", value);
  }
  function changerPourcentExt(e, value) {
    e.preventDefault();
    setPourcentExt(value);
    setMsgErreurPourcentExt("");
    mem.changerChampLot("pourcentExt", value);
  }
  function changerCarbone(e, value) {
    e.preventDefault();
    setCarbone(value);
    setMsgErreurCarbone("");
    mem.changerChampLot("carbone", value);
  }
  function changerDLC(e, value) {
    e.preventDefault();
    setDLC(value);
    setMsgErreurDLC("");
    mem.changerChampLot("DLC", value);
  }

  function annulerImage(e) {
    setImage("");
    mem.changerChampLot("image", "");
    setMsgErreurImage("");
    setFile();
    setFileName("");
    setTilt(!tilt);
  }

  //si usitilisateur clique sur tout effacer
  function proposerAnnulerLot(e) {
    e.preventDefault();
    setShowAnnuler(true);
  }

  function annulerLot(e) {
    e.preventDefault();
    setShowAnnuler(false);

    setNumFournisseur("");
    mem.changerChampLot("numFournisseur", "");
    setMsgErreurNumFournisseur("");
    setLibelle("");
    mem.changerChampLot("libelle", "");
    setMsgErreurLibelle("");
    setImage("");
    mem.changerChampLot("image", "");
    setMsgErreurImage("");
    setDescr("");
    mem.changerChampLot("descr", "");
    setMsgErreurDescr("");
    setArg("");
    mem.changerChampLot("arg", "");
    setMsgErreurArg("");
    setNbreArt("");
    mem.changerChampLot("nbreArt", "");
    setMsgErreurNbreArt("");
    setPourcentExt("");
    mem.changerChampLot("pourcentExt", "");
    setMsgErreurPourcentExt("");
    setCarbone("");
    mem.changerChampLot("carbone", "");
    setMsgErreurCarbone("");
    setDLC("");
    mem.changerChampLot("DLC", "");
    setMsgErreurDLC("");
    mem.changerChampLot("couleur", "black");
    setCouleurTitre("black");

    mem.annulerTousSousLotsEnMemoire(); //on annule tout en mémoire aussi (sauvegarde dans recopier)
    setInputList([]);
    setLotsCount(1);
    //inutile... on a déjà tout mis à blanc
    // mem.resetLotEnMemoire()
    // mem.resetLesSousLotsEnMemoire()
    annulerImage();
    // setTilt(!tilt);
  }
 
  // function testerNombre(nbre) {   //cette fonction existait en double!!
  //   let nbrecorrect = /^[0-9]+$/i;
  //   let res = nbrecorrect.test(nbre);
  //   if (DEBUG) console.log("dans FormCreerLot, nbre: ", nbre, "resultat: ", res);
  //   return res;
  // }


  //un pourcentage est constitué de 4 chiffres 4500, 9267,... pour 45%, 92,67%...
  function testerPourcentage(pour) {
    let nbrecorrect = /^[0-9]{4,4}$/i;
    let res = nbrecorrect.test(pour);
    if (DEBUG) console.log("pour: ", pour, "resultat: ", res);
    return res;
  }

  function testerDate(dlc) {
    // let datecorrecte = /^[0-3][0-9]\/[0-1][0-2]\/[0-2][0-1][0-9][0-9]$/i;
    let datecorrecte = /^[0-3][0-9]\/((0[0-9])|(1[0-2]))\/[0-2][0-1][0-9][0-9]$/i;
    let res = datecorrecte.test(dlc);
    if (DEBUG) console.log("pour: ", dlc, "resultat: ", res);
    return res;
  }

  //les fonctions de validation de chacun des champs
  function validerNumFournisseur() {
    //verifier
    if ((numFournisseur.trim()).length > 0) {
      return true;
    }
    setMsgErreurNumFournisseur(
      "--erreur sur le numero de Lot chez le Fournisseur--"
    );
    return false;
  }

  function validerLibelle() {
    if ((libelle.trim()).length > 0) {
      return true;
    }
    setMsgErreurLibelle("--erreur sur la dénomination du Lot--");
    return false;
  }

  function validerDescr() {
    if ((descr.trim()).length > 0) {
      return true;
    }
    setMsgErreurDescr("--erreur sur le descriptif du Lot--");
    return false;
  }

  function validerArg() {
    if ((arg.trim()).length > 0) {
      return true;
    }
    setMsgErreurArg("--erreur sur l'argumemntaire--");
    return false;
  }

  function validerNbreArt() {
    // if (nbreArt.length > 0) {
    if (testerNombre(nbreArt.trim())) {
      return true;
    }
    setMsgErreurNbreArt("--erreur sur le nombre d'articles--");
    return false;
  }

  function validerPoucentExt() {
    // if (nbreArt.length > 0) {
    if (testerPourcentage(pourcentExt.trim())) {
      return true;
    }
    setMsgErreurPourcentExt(
      "--erreur sur le pourcentage d'ingrédients extérieurs--"
    );
    return false;
  }

  function validerCarbone() {
    // if (nbreArt.length > 0) {
    if (carbone.trim() == "" || testerNombre(carbone.trim())) return true;
    setMsgErreurCarbone("--erreur sur l'empreinte carbone--");
    return false;
  }

  function validerDLC() {
    // if (nbreArt.length > 0) {
    if (DLC.trim() == "" || testerDate(DLC.trim())) return true;
    setMsgErreurDLC("--erreur sur la DLC--");
    return false;
  }

  function validerImage() {
    if (image.length > 0) {
      return true;
    }
    setMsgErreurImage("Rappel: vous n'avez pas spécifié de fichier image");
    return true;
  }

  async function calculerCarboneTotEtPert() {
    //calcul de carnoneTot...pour le lot principal
    //total des pourcentages carbone renseignés
    var lesSousLots = mem.lesSousLotsEnMemoire;
    var carbTot = 0;
    var TotCarbRenseignes = 0;
    if (parseInt(carbone, 10) > 0) {
      TotCarbRenseignes += (10000 - parseInt(pourcentExt, 10)) / 10000;
      carbTot +=
        parseInt(carbone, 10) * ((10000 - parseInt(pourcentExt, 10)) / 10000);
    }
    for (let i = 0; i < lesSousLots.length; i++) {
      var sousL = lesSousLots[i];
      if (sousL["type"] == "traceur") {
        let numL = parseInt(sousL["numTraceur"], 10);
        let infosCarb = await intchaine.getInfosCarbone(numL);
        let carbTotTraceur = parseInt(infosCarb[0],10);
        let carbPertTraceur = infosCarb[1];
        if (carbPertTraceur && (parseInt(sousL["carboneRaj"], 10) >= 0)) {
          TotCarbRenseignes += (parseInt(sousL["pourcent"], 10)) / 10000;
          carbTot += (carbTotTraceur + parseInt(sousL["carboneRaj"], 10)) * ((parseInt(sousL["pourcent"], 10)) / 10000);
        }
      }
      if (sousL["type"] == "fournisseur") {
        if ((!(parseInt(sousL["carbone"],10) >= 0)) || !(parseInt(sousL["carboneRaj"],10) >= 0))    {sousL["carbonePert"] = false;}
        else {sousL["carbonePert"] = true;}
        if (sousL["carbonePert"]) {          
          TotCarbRenseignes += parseInt(sousL["pourcent"], 10) / 10000;
          carbTot +=
            (parseInt(sousL["carbone"], 10) +
              parseInt(sousL["carboneRaj"], 10)) *
            (parseInt(sousL["pourcent"], 10) / 10000);
        }
      }
    }

    if (DEBUG) console.log("TotCarbRenseignes: ", TotCarbRenseignes);
    if (DEBUG) console.log("carbTot: ", carbTot);
    let carboneTottemp = 0;
    let carbonePerttemp = true;
    //ici calcul de carboneTot et carbonePert pour le lot principal
    if (TotCarbRenseignes < 0.95) {
      carbonePerttemp = false;
      carboneTottemp = Math.floor(carbTot);
    } else {
      carboneTottemp = Math.floor(carbTot / TotCarbRenseignes);
    }
    mem.changerChampLot("carboneTot", carboneTottemp);
    mem.changerChampLot("carbonePert", carbonePerttemp);
  }

  async function goCreerLot(e) {
    e.preventDefault();
    // var lesSousLots = mem.lesSousLotsEnMemoire;
    if (!intchaine.accountFournisseur) {
      setMsgModal("Vous n'avez pas selectionné de compte Metamask");
      setShow(true);
      return;
    }
    let identF = await intchaine.getIdFournisseurParAdresse(
      intchaine.accountFournisseur
    );
    if (identF == 0) {
      setMsgModal("Pas de fournisseur connu avec ce compte Metamask");
      setShow(true);
      return;
    }
    //on vérifie tous les champs
    let correct = true;
    if (!validerNumFournisseur()) {
      correct = false;
    }
    if (!validerLibelle()) {
      correct = false;
    }
    if (!validerDescr()) {
      correct = false;
    }
    if (!validerArg()) {
      correct = false;
    }
    if (!validerNbreArt()) {
      correct = false;
    }
    if (!validerPoucentExt()) {
      correct = false;
    }
    if (!validerCarbone()) {
      correct = false;
    }
    if (!validerDLC()) {
      correct = false;
    }
    if (!validerImage()) {
      correct = false;
    }

    if (!correct) {
      mem.changerChampLot("couleur", "red");
    } else {
      mem.changerChampLot("couleur", "black");
    }
        
    let sousLotsValides = await mem.validerSousLots();   
    if (DEBUG)  console.log("dans valider creerLot, SOUSLOTSVALIDES= ", sousLotsValides);
    if (!sousLotsValides) {
      correct = false;
    }
    if (correct && !mem.verifierSommePourcentages()) {
      setMsgModal("Ereur: La somme des pourcentages est supérieure à 100%");
      setShow(true);
    }
    if (!correct) {
      setMsgModal("Erreur: Lot non valide, vérifiez les champs incorrects");
      setShow(true);
    } else if (mem.verifierSommePourcentages()) {
      let lotsnontraceurs = await mem.listeLotsNonTraceurs();
      if (lotsnontraceurs.length > 0) {
        if (DEBUG) console.log("liste lots non traceur: ", lotsnontraceurs)
        setMsgModal(
          "Erreur: le(s) lot(s) [" +
            lotsnontraceurs.toString() +
            "] ne sont pas des lots Traceur sur la blockchain"
        );
        setShow(true);
      } else if (!mem.lotsDistincts()) {
        if (DEBUG) console.log("Des sous-lots traceur identiques!")
        setMsgModal("Erreur: Des sous-lots traceur identiques");        
        setShow(true);        
      } else {
        if (DEBUG) console.log("Creation du Lot");
        calculerCarboneTotEtPert();
        try {
          // try catch inutile...
          setCreationLot(true);
        } catch (e) {
          setMsgModal("Erreur dans la création du Lot sur la blockchain");
          setShow(true);
        }
      }
    }
    // si erreur dans les sous-lots on les réaffiche en demandant de vérifier et de mettre les messages d'erreurs adéquats
    if (!sousLotsValides) {
      var lesSousLots = mem.lesSousLotsEnMemoire;
      // console.log(lesSousLots);
      var listetemp = [];
      for (var i = 0; i < lesSousLots.length; i++) {
        let identSousLot = lesSousLots[i]["ident"];
        let typeSousLot = lesSousLots[i]["type"];
        // let couleurSousLot = lesSousLots[i]["couleur"];
        // console.log("identSousLot: ", identSousLot);
        listetemp = [
          ...listetemp,
          {
            id: identSousLot,
            jsx: (
              <>
                <FormSousLot
                  ident={identSousLot}
                  type={typeSousLot}
                  verif={true} //cette fois on demande la vérification
                  open={false}
                  // couleur={couleurSousLot}
                />
                <p
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={(event) => clickRemoveSousLot(event, identSousLot)}
                >
                  - Supprimer le sous-lot {identSousLot}
                </p>
                {/* <br></br> */}
              </>
            ),
          },
        ];
        setLotsCount(identSousLot + 1);
      }
      setInputList(listetemp);

      // setVerifErreur(true)
    }
  } //fin goCreerLot

  function testerNombre(nbre) {
    let nbrecorrect = /^[0-9]+$/i;
    let res = nbrecorrect.test(nbre);
    if (DEBUG) console.log("nbre: ", nbre, "resultat: ", res);
    return res;
  }

  //validation de la taille du fichier image
  function testerFichierTaille(fich) {
    let tailleFichier = fich.size;
    if (DEBUG) console.log("dans tester taille, fich.size= ", tailleFichier);
    return tailleFichier < 100000; //limite 100k
  }

  //validation de l'extension du fichier image
  function testerFichierExtension(nomF) {
    let allowedExtensions = /(\.jpg|\.webp|\.jpeg|\.png|\.gif\.pdf)$/i;
    let res = allowedExtensions.test(nomF);
    if (DEBUG) console.log("file: ", nomF, "allowed extension: ", res);
    return res;
  }

  const saveFile = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
    if (DEBUG) console.log("nom du fichier sauvé : ", fileName);
  };

  //pour rajouter un suffixe (qui sera un nombre aléatoire) dans le nom du fichier
  function coderNomFichier(nomF, suffixe) {
    let reg = /(^[a-z0-9._/-]+)\.([a-z]+)$/i;
    reg.exec(nomF);
    return RegExp.$1 + suffixe + "." + RegExp.$2;
  }

  //pour enlever ce suffixe et rétablir le nom original pour affichage
  function decoderNomFichier(nomF) {
    let reg = /(^[a-z0-9._/-]+)_[0-9]+\.([a-z]+)$/i;
    reg.exec(nomF);
    return RegExp.$1 + "." + RegExp.$2;
  }

  // upload en appelant le serveur d'images en donnant nom et suffixe
  const uploadFile = async (e) => {
    if (DEBUG) console.log("file dans upload: ", fileName);
    if (!file) {
      setImage("");
      mem.changerChampLot("image", "");
      return;
    }
    if (!testerFichierTaille(file)) {
      setImage("");
      mem.changerChampLot("image", "");
      setMsgModal("Fichier trop grand (limite 100 Ko)");
      setShow(true);
      return;
    }
    if (!testerFichierExtension(fileName)) {
      setImage("");
      mem.changerChampLot("image", "");
      setMsgModal("Fichier avec extension non supportée");
      setShow(true);
      return;
    }

    //constitution des paramètres pour la requête au serveur d'images
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);
    // on fabrique un nombre aléatoire entre 1 et 10 millions... qu'on va envoyer dans la requête
    let suffixe = "_" + Math.floor(Math.random() * 10000000).toString();
    formData.append("suffixe", suffixe);

    //appel au serveur d'images
    try {
      if (DEBUG) console.log("j'appelle le serveur d'images");
      // const res = await axios.post("http://localhost:3008/upload", formData);
      const res = await axios.post(
        "https://" + mem.addressIPRemoteimages + ":3008/upload",
        formData
      );
      //on va sauvegarder le nom du fichier avec son suffixe pour pouvoir le demander ensuite au serveur d'images
      let nouveauNom = coderNomFichier(fileName, suffixe);
      setImage(nouveauNom);
      mem.changerChampLot("image", nouveauNom);

      if (DEBUG) console.log(res.data.message);
    } catch (ex) {
      if (DEBUG) console.log(ex);
      if (DEBUG)
        console.log(
          "erreur dans le chargement de l'image de fichier: ",
          fileName + suffixe
        );
    }
  };

  // on reconstitue la liste des sous-lots
  const liste = inputList.map((inp) => <div key={inp.id}>{inp.jsx}</div>);

  // pour l'instant on autorise tout le monde
  // const autorise = intchaine.fournisseurEstAutorise
  const autorise = true;

  if (!autorise) {
    return <p>Vous devez demander une autorisation</p>;
  } else {
    return (
      <>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={(e) => proposerAnnulerLot(e)}
        >
          Tout Effacer
        </Button>
        <br />
        <br />
        <h4 style={{color: couleurTitre, backgroundColor: "lightblue" }} className="ps-2">
          Nouveau Lot
          <span
            className="ms-5"
            onClick={() => setOpen(!open)}
            style={{ cursor: "pointer" }}
          >
            {open ? <BsFillArrowUpSquareFill /> : <BsFillArrowDownSquareFill />}
          </span>
        </h4>
        <Collapse in={open}>
          <Form>
            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Dénomination du lot</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez la dénomination du lot"
                value={libelle}
                maxLength={1000}
                onChange={(e) => changerLibelle(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurLibelle && msgErreurLibelle}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                Numero de Lot chez le Fournisseur
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le numero de lot chez le Fournisseur"
                value={numFournisseur}
                maxLength={1000}
                onChange={(e) => changerNumFournisseur(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurNumFournisseur && msgErreurNumFournisseur}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Description du Lot</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="entrez la description du lot"
                value={descr}
                maxLength={1000}
                onChange={(e) => changerDescr(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurDescr && msgErreurDescr}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Argumentaire</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="entrez votre argumentaire pour ce lot"
                value={arg}
                maxLength={1000}
                onChange={(e) => changerArg(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurArg && msgErreurArg}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                Pourcentage d'ingrédients extérieurs (6400 pour 64%, 4865 pour
                48,65%...)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le pourcentage, en masse,  d'ingrédients extérieurs"
                value={pourcentExt}
                maxLength={1000}
                onChange={(e) => changerPourcentExt(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurPourcentExt && msgErreurPourcentExt}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                (optionnel) Empreinte carbone des ingrédients internes (en
                gCO2/Kg)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez l'empreinte carbone "
                value={carbone}
                maxLength={1000}
                onChange={(e) => changerCarbone(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurCarbone && msgErreurCarbone}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                (optionnel) Date limite consommation (format: jj/mm/aaaa)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez la DLC "
                value={DLC}
                maxLength={1000}
                onChange={(e) => changerDLC(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurDLC && msgErreurDLC}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                Nombre d'articles qui seront distribués
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le nombre d'articles"
                value={nbreArt}
                maxLength={1000}
                onChange={(e) => changerNbreArt(e, e.target.value)}
              />
              <Form.Text className="text-muted">
                cette information ne sera pas inscrite dans la blockchain
              </Form.Text>
              <br />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {msgErreurNbreArt && msgErreurNbreArt}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                Fichier image (.png, .jpg, .jpeg, .gif, .pdf, taille de moins de
                500 ko){" "}
              </Form.Label>
              <Form.Control
                type="file"
                key={tilt} //astuce...
                onChange={saveFile}
              />
              <span style={{ color: "blue", fontStyle: "italic" }}>
                {!image &&
                  "Vous n'avez pas chargé de fichier image (optionnel)"}
                {/* {msgErreurImage && msgErreurImage} */}
              </span>
              <span style={{ color: "blue" }}>
                {image &&
                  "Votre fichier '" +
                    decoderNomFichier(image) +
                    "' a été chargé, vous pouvez le modifier"}{" "}
              </span>
              <br />
              <Button
                // size="sm"
                style={{ fontSize: 12, padding: 3 }}
                variant="outline-primary"
                // style={{ color: "lightblue" }}
                onClick={uploadFile}
              >
                charger fichier image
              </Button>{" "}
              &nbsp;&nbsp;
              <Button
                // size="sm"
                style={{ fontSize: 12, padding: 3 }}
                variant="outline-primary"
                // style={{ color: "lightblue" }}
                onClick={annulerImage}
              >
                annuler fichier image
              </Button>
            </Form.Group>
          </Form>
        </Collapse>
        {/* la liste des sous-lots qu'on construite plus haut */}
        <br/>
        {liste}
        <Container>
          <Row>
            <Col></Col>
            <Col xs={7}>
              <Button
                // size="sm"
                style={{ fontSize: 12, padding: 3 }}
                variant="outline-primary"
                // style={{ color: "lightblue" }}
                onClick={(e) => clickRajouterSousLot(e, "traceur")}
              >
                +ajouter un sous-lot "Traceur"
              </Button>{" "}
              <Button
                // size="sm"
                style={{ fontSize: 12, padding: 3 }}
                variant="outline-primary"
                // style={{ color: "lightblue" }}
                onClick={(e) => clickRajouterSousLot(e, "fournisseur")}
              >
                +ajouter un sous-lot "Fournisseur"
              </Button>
            </Col>
            <Col></Col>
          </Row>
        </Container>
        <br />
        <Button variant="primary" onClick={(e) => goCreerLot(e)}>
          Vérifier et Creer Lot
        </Button>{" "}
        <Button variant="secondary" onClick={(e) => proposerAnnulerLot(e)}>
          Tout Effacer
        </Button>
        <br />
        <br />
        {/* modal pour les messages d'erreur           */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Création Lot</Modal.Title>
          </Modal.Header>
          <Modal.Body>{msgModal}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {/* modal pour confirmer tout effacer          */}
        <Modal show={showAnnuler} onHide={handleCloseAnnuler}>
          <Modal.Header closeButton>
            <Modal.Title>Création Lot</Modal.Title>
          </Modal.Header>
          <Modal.Body>Etes-vous sûr de vouloir tout effacer?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAnnuler}>
              Non
            </Button>
            <Button variant="secondary" onClick={(e) => annulerLot(e)}>
              Oui
            </Button>
          </Modal.Footer>
        </Modal>
        {/* modal pour confirmer suppression sous-lot         */}
        <Modal show={showSuppSousLot} onHide={handleCloseSuppSousLot}>
          <Modal.Header closeButton>
            <Modal.Title>Création Lot</Modal.Title>
          </Modal.Header>
          <Modal.Body>{msgModalSuppSousLot}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuppSousLot}>
              Non
            </Button>
            <Button variant="secondary" onClick={(e) => suppSousLot(e)}>
              Oui
            </Button>
          </Modal.Footer>
        </Modal>

        {/* grand modal pour tout revoir du lo, on passe une fonction en paramètre! */}
        {creationLot && (
          <ModalCreationLot montrer={true} reset={setCreationLot} />
        )}
      </>
    );
  }
}
